import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxChooser from '../../cx/CxChooser';
import CxNumber from '../../cx/CxNumber';
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import CxSnackbar from '../../cx/CxSnackbar';
import CxDialog from '../../cx/CxDialog';
import { StoreSettPosTax } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxInput from '../../cx/CxInput';


const MxSettSlsTaxForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  
  let r_form = React.useRef(null);
  let rf_txTypeTaxGroup = React.useRef(null);
  
  const r_snack_existing_type = React.useRef(null);
  const r_snack_record_used = React.useRef(null);

  const [storeSettPosTax, setStoreSettPosTax] = useSessionStorage('StoreSettPosTax', StoreSettPosTax);

  const [dlgAddNewGroup, setDlgAddNewGroup] = React.useState(false);
  const rf_group_new = React.useRef(null);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
      // no se puede crear dos veces un mismo tipo
      r_snack_existing_type.current.setOpen(true);
    } else {
      storeSettPosTax.itTax = lastSaveRv.theValue;
      Promise.all([setStoreSettPosTax(storeSettPosTax)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
    if (rv.theValue==='rv_ps_using_tax') {
      r_snack_record_used.current.setOpen(true);
    }
  }

  const doAddTaxGroup = () => {
    setDlgAddNewGroup(true);
  }

  const doCreateTaxGroup = (taxDTO) => {
    try {
      setDlgAddNewGroup(false);

      let record = {};
      if (taxDTO) {
        record['txTypeTaxGroup'] = taxDTO.txTypeTaxGroup;
      }

      Promise.all([FxFetch.doJsonX('sett/tax/group/c', record)]).then((result) => {
        if (result[0]) {
          rf_txTypeTaxGroup.current.getTable().redisplay();
        }
      });

    } catch (error) {
      FxLog.errorx("MxSettSlsTaxForm.doCreateTaxGroup", error);
    }
  }

  return (
    <div>
      <GxForm 
        moduleName={trans('field.tax')}
        xref={r_form}
        url="sett/tax" 
        filterIdField='itTax'
        filterIdValue={storeSettPosTax.itTax} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_tax.itTax" value={storeSettPosTax.itTax || ''} />

        <CxChooser xref={rf_txTypeTaxGroup} label={trans('field.type')}
          dbfield="t_tax_group.txTypeTaxGroup" dbfieldkey={`t_tax.itTaxGroup`}
          table="t_tax_group"
          col_id="itTaxGroup"
          col_tx="txTypeTaxGroup"
          onButtonAdd={doAddTaxGroup}
          required
        />

        <CxNumber xref={useRef(null)} label={trans('field.tax_perc')} dbfield="t_tax.nuTaxPerc"  required />
        
      </GxForm>

      <CxDialog
        title={trans('field.new_1')}
        open={dlgAddNewGroup}
        onOk={() => doCreateTaxGroup({ txTypeTaxGroup: rf_group_new.current.getVal() })}
        onCancel={() => setDlgAddNewGroup(false)}
        height='200px'>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: 'var(--ibs_control_width_lg)' }}>
          <CxInput xref={rf_group_new} label={trans('field.group')}  />
        </div>
      </CxDialog>

      <CxSnackbar xref={r_snack_existing_type} severity="error" value={trans('msg.existing_x','field.type')} />
      <CxSnackbar xref={r_snack_record_used} severity="error" value={trans('msg.record_used')} />
      
    </div>
  );

}

export default MxSettSlsTaxForm;
